/**
 * Метка поверх фотографии: бейдж места, расстояние, метка рекламы.
 *
 * Один компонент на все случаи — до этого реклама рисовала свою копию
 * инлайном, и метки разошлись: 13px/600 против 12px, 32px высоты против
 * высоты по содержимому, поля 12px против 8px.
 *
 * Кегль — `kicker` 12/600 (брендбук 3.2). Вес приходит из самого токена:
 * прежний `caption` с `font-semibold` перебивал шкалу, в которой
 * caption — 400.
 *
 * Радиус — `radius-sm` 6px (брендбук 10.2: «бейджи, мелкие метки»).
 * `radius-full` шкала отдаёт только круглым кнопкам и аватарам.
 *
 * @param {string} label - Текст метки
 * @param {() => void} [onClick] - Делает метку нажимаемой (метка рекламы)
 * @param {string} [ariaLabel] - Что произойдёт по нажатию
 */
const CustomBadge = ({ label, onClick, ariaLabel }) => {
  if (!label) return null;

  // Без backdrop-filter: размытие пересчитывается каждый кадр и роняет
  // плавность горизонтальных слайдеров на Android — брендбук 5.4.
  // Фон вместо этого плотнее. Теней в системе нет — брендбук 10.3
  //
  // Белой рамки нет: на светлом снимке она читалась свечением по краям.
  // Пара «фон .28 + граница .3» в брендбуке 5.4 задана кнопке избранного,
  // а не метке — у метки оттуда только положение. Отделяет её от фото
  // теперь сама подложка, поэтому она плотнее: .55 против прежних .28.
  //
  // Плотность выбрана расчётом, а не на глаз. Под меткой произвольное
  // фото, и худший случай — белый снимок: при .28 белый текст давал
  // на нём 1.99 при норме 4.5, при .55 даёт 4.76
  const style = {
    background: 'rgba(0, 0, 0, 0.55)',
    borderRadius: 'var(--radius-sm)',
  };

  const className =
    'inline-flex h-7 items-center justify-center px-2 text-kicker leading-none text-white tabular';

  if (onClick) {
    return (
      <button
        type="button"
        onClick={onClick}
        aria-label={ariaLabel}
        className={`${className} transition-opacity duration-fast ease-out active:opacity-80`}
        style={{ ...style, WebkitTapHighlightColor: 'transparent' }}
      >
        {label}
      </button>
    );
  }

  return (
    <span className={className} style={style}>
      {label}
    </span>
  );
};

export default CustomBadge;
